module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.4018/img/cms-free-signup.png"